import { JWTAuth } from "../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../lib/js-apiclient/src/AdvancedApiClient";

export class AreaApiClient extends AdvancedApiClient {

    static entityType = "Area"

    constructor(token, id) {
        super();

        this.setEntityType(AreaApiClient.entityType);

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/area/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/area")
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}